import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProctorService } from '../services/proctor.service';
import { ProctorLevels } from '../proctor/app-proctor.component';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from '../services/util.service';

@Component({
  selector: 'app-second-view',
  templateUrl: './second-view.component.html',
  styleUrls: ['./second-view.component.css']
})
export class SecondViewComponent implements OnInit, AfterViewInit {
  accessCodeEntered: boolean = false;
  interactive: boolean = false;
  proctoringHasStarted = false;
  @ViewChild('secondVideo') secondVideo: ElementRef;
  secondViewCandidateNumber: string;
  secondViewAccessCode: string;
  loggedIn: boolean = false;
  interactiveStartSecondViewEventData: any;
  connected: boolean = false;
  connecting: boolean = false;
  loggingIn: boolean = false;
  uploadSecondViewSnapshotInterval: any;
  secondViewVideoCanvas: HTMLCanvasElement;
  interactiveSecondViewDeviceId: string;
  examHasEnded: boolean = false;
  checkForExamEndedInterval: any;
  qrCodeUsed: boolean = false;
  instructionsCheckboxChecked: boolean = false;
  constructor(private proctorService: ProctorService, private activatedRoute: ActivatedRoute, private toastr: ToastrService, private util: UtilService){
    this.proctorService.isSecondViewProctor = true;
    this.interactive = this.activatedRoute.snapshot.queryParams.interactive == "true";
    this.proctorService.isInteractiveSecondView = this.interactive;
  }

  ngOnInit(): void {
    if(this.activatedRoute.snapshot.queryParams.source == 'qrcode'){
      this.secondViewCandidateNumber = this.activatedRoute.snapshot.queryParams.candidateNo;
      this.secondViewAccessCode = this.activatedRoute.snapshot.queryParams.accessCode;
      this.qrCodeUsed = true;
    }
  }

  ngAfterViewInit(): void {
    window.addEventListener('message', async (evt) => {
      console.log('second view');
      console.log(evt.data);
      const messageid = evt.data.messageid;
      if (!messageid) {
        console.error(new Error('messageid not set'));
        return;
      }
      const ret: any = { messageid: messageid };

      try {
        if (evt.data.operation === 'start') {
          console.log('called start - ');
          //await this.startSecondViewProctorVideoStream(evt.data);
          await this.startSecondViewProctor(evt.data);
        }
        // else if(evt.data.operation === 'connecttoproctoringmeeting'){
        //   console.log('signal to connect to proctor meeting received');
        //   if(this.proctoringHasStarted){
        //     console.log('starting live proctor from signal');
        //     this.proctorService.startLiveProctor(false, false, this.proctorService.allowExternalWebcam);
        //   }
        // }
        else if (evt.data.operation === 'stop') {

          this.proctoringHasStarted = false;

          await this.stopSecondViewProctor(evt.data, true);
          //ret.status = 'done';
        }
        // else if (evt.data.operation === 'checkpublishing') {
        //   if (this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctoredOnly || this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist) {
        //     //the minimum requirement should be recording
        //     ret.publishing = this.proctorService.recording(); //this.proctorService.producing('video') && this.proctorService.producing('audio') && this.proctorService.recording();
        //   }
        //   else if (this.proctorService.proctorInfo.proctorLevel == ProctorLevels.RecordOnly || this.proctorService.proctorInfo.proctorLevel == ProctorLevels.AiProctoredOnly) {
        //     ret.publishing = this.proctorService.recording();
        //   }
        //   else {
        //     ret.publishing = false;
        //   }
        // }
        else if (evt.data.operation === 'loading') {
          // console.log('loading...');
          // // let loadingdiv = document.getElementById('loadingdiv');
          // // loadingdiv.style.display = 'block';
          // this.loadingDivComponent.loading = true;
        }
        else if (evt.data.operation === 'loaded') {
          // console.log('loaded');
          // // let loadingdiv = document.getElementById('loadingdiv');
          // // loadingdiv.style.display = 'none';
          // this.loadingDivComponent.loading = false;
        }
        
        ret.success = true;
      }
      catch (error) {
        console.error(error);
        ret.success = false;
        ret.message = error?.message ?? error;
      }

      if(window != window.parent && window.parent){
        window.parent.postMessage(ret, '*');
      }
    });
  }

  private async stopSecondViewProctor(data: any, stopSnapshotInterval: boolean){
    try{
      if(stopSnapshotInterval && this.uploadSecondViewSnapshotInterval){
        clearInterval(this.uploadSecondViewSnapshotInterval);
      }
      await this.proctorService.stopProctorEventHandler(data);
    }
    catch(error){
      console.error(error);
    }
  }

  private async startSecondViewProctor(data: any) {
    await this.stopSecondViewProctor(data, false);
    await this.startSecondViewProctorVideoStream(data, this.interactive ? this.interactiveSecondViewDeviceId : undefined);
    await this.proctorService.startProctoringEventHandler(data);

    this.proctoringHasStarted = true;
  }

  private async startSecondViewProctorVideoStream(data: any, forcedDeviceId: string = undefined) {
    const stream = this.proctorService.videostream;

    if (stream) {
      [...stream?.getVideoTracks(), ...stream?.getAudioTracks()].forEach((track) => {
        track.stop();
      });
    }

    this.proctorService.videostream = null;

    this.proctorService.primaryViewDeviceLabel = data.primaryViewWebcamDeviceLabel;
    this.proctorService.secondViewDeviceLabel = data.secondViewDeviceLabel;

    if (this.interactive/* || !environment.production*/) {
      this.secondVideo.nativeElement.muted = true;
      const stream = await this.proctorService.getVideoStream(this.proctorService.allowExternalWebcam, forcedDeviceId);
      this.secondVideo.nativeElement.srcObject = stream;

      //in interactive view, we want to take periodic snapshots of the video and upload it to s3
      //this way, we can show the user what the angle looks like on their computer
      const videoSettings = stream.getVideoTracks()[0].getSettings();

      this.secondViewVideoCanvas = document.createElement("canvas");
      this.secondViewVideoCanvas.width = videoSettings.width;
      this.secondViewVideoCanvas.height = videoSettings.height;
      
      
    }

    return stream;
  }

  //TODO: keep screen on so that camera doesn't stop recording
  //TODO: detect when screen has gone off/camera stops sending new frames
  //Track the meeting the candidate is in and switch when candidate switches

  async loginClicked(){
    //use authentication details to get exam and schedule id
    //populate the data object with the fields used below
    //call startSecondViewProctor

    //this request must be made before any asynchronous calls
    try{
      await this.rotateScreen();
    }
    catch(error){
      console.error(error);
      // if(screen.orientation.type != 'landscape-primary' && screen.orientation.type != 'landscape-secondary'){
      //   //we were not able to automatically request landscape mode and the device is not already in landscape mode
      //   //the user will need to set it manually
      //   this.toastr.error('Please place your phone in landscape mode to proceed');
      //   return;
      // }
    }

    try{
      this.loggingIn = true;
      let _data;

      try{
        _data = await this.proctorService.candidateSecondViewAuth(this.secondViewCandidateNumber, this.secondViewAccessCode);
      }
      catch(error){
        this.toastr.error('Authentication error. Please confirm the access code and candidate number are correct');
        return;
      }

      const data: any = {};

      let skipAIPassportCheck =  _data.examSkipAIPassportCheck || _data.candidateSkipAIFaceMatching || _data.scheduleOverrideAIPreventExamStart || (!_data.starting && environment.production);

      data.isSecondViewProctor = true;
      data.isInteractiveSecondView = true;
      data.examid = _data.examId;
      data.username = _data.username;
      data.attempt = _data.attempt;
      data.name = _data.name;
      data.passportversion = _data.passportVersion;
      data.passporttype = _data.passportType;
      data.aiCheckPhotoBeforeStart = _data.passportVersion > 0 && !skipAIPassportCheck,
      //data.passporturl
      data.scheduleid = _data.scheduleId;
      data.allowExternalSecondViewWebcam = _data.allowExternalSecondViewWebcam;
      data.secondViewRequired = _data.secondViewRequired;
      data.startSecondViewProctor = false;

      //these have to be set early
      this.proctorService.loggedInUsername = data.username;
      this.proctorService.examid = data.examid;
      this.proctorService.scheduleid = data.scheduleid;

      const widestDevice = await this.proctorService.getWidestCameraDevice({facingMode: 'user'});

      data.secondViewDeviceLabel = widestDevice?.label;
      this.interactiveSecondViewDeviceId = widestDevice?.deviceId;

      this.interactiveStartSecondViewEventData = data;

      await this.startSecondViewProctorVideoStream(data, widestDevice.deviceId);

      this.loggedIn = true;

      setTimeout(() => {
        window.scrollTo({ left: 0, top: 1000000000, behavior: 'smooth'});
      }, 1000);
      

      const _checkForExamEnded = async () => {
        const examEnded: boolean = await this.proctorService.checkExamEndedFromInteractiveSecondView(this.secondViewAccessCode);
        if(examEnded){
          if(this.checkForExamEndedInterval){
            clearInterval(this.checkForExamEndedInterval);
          }
          await this.stopSecondViewProctor(data, true);
          this.examHasEnded = examEnded;
        }
      };

      _checkForExamEnded();
      this.checkForExamEndedInterval = setInterval(() => {
        _checkForExamEnded();
      }, 5000);
    }
    catch(error){
      this.toastr.error('Error initiating second view streaming');
      throw error;
    }
    finally{
      this.loggingIn = false;
    }
  }

  async connectClicked(){
    try{
      this.connecting = true;

      await this.startSecondViewProctor(this.interactiveStartSecondViewEventData);

      if(this.interactive){
        
        const _uploadSecondViewSnapshot = async () => {
          this.util.takeVideoSnapshot(this.secondVideo.nativeElement, this.secondViewVideoCanvas);
          const imageDataUrl = this.secondViewVideoCanvas.toDataURL('image/jpeg');
          this.proctorService.uploadSecondViewSnapshot(this.secondViewAccessCode, imageDataUrl);
          //upload image to api
          //set version number
          //we need to stop this once the user has continued with the exam because we don't want to keep locking the schedule file for no reason
        }

        this.uploadSecondViewSnapshotInterval = setInterval(async () => {
          if(!(await this.proctorService.getSecondViewAnglesAcceptedFromInteractiveSecondView(this.secondViewAccessCode))){
            await _uploadSecondViewSnapshot();
          }
        }, 2000);
      }

      this.connected = true;
    }
    catch(error){
      this.connected = false;
    }
    finally{
      this.connecting = false;
    }
  }

  async rotateScreen(){
    if(typeof document.documentElement.requestFullscreen === 'function'){
      await document.documentElement.requestFullscreen();
      await (screen.orientation as any).lock("landscape");
    }
    else{
      throw new Error('requestFullscreen function not found');
    }
  }
}
